// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing133({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/133/1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/133/2.jpg`}
      // img3Path={`${process.env.REACT_APP_CDN_BASE}/images/133/01_241216_04.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/133/3.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      qOptionColor="teal"
      questionType="btn"
      qOptions={["1~4개", "5개 이상", "전체", "상담필요"]}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/costBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing133;
